import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const LEGAL_UPDATED = 'June 2026';

export const LegalLayout = ({ title, testId, children }) => {
  useEffect(() => { document.title = `${title} | PractCom`; window.scrollTo(0, 0); }, [title]);
  return (
    <div className="min-h-screen bg-white" data-testid={testId}>
      <header className="border-b border-slate-200 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-5 flex items-center justify-between gap-4">
          <Link to="/landing" className="flex items-center gap-2 text-sky-800 font-semibold hover:underline" data-testid="legal-back-link">
            <ArrowLeft className="w-4 h-4" /> Back to PractCom
          </Link>
          <p className="text-sm text-slate-500">Last updated: {LEGAL_UPDATED}</p>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 text-slate-700 leading-relaxed [&_h1]:text-4xl [&_h1]:font-extrabold [&_h1]:text-slate-900 [&_h1]:mb-6 [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-slate-900 [&_h2]:mt-10 [&_h2]:mb-4 [&_h3]:text-lg [&_h3]:font-bold [&_h3]:text-slate-900 [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:my-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-4 [&_li]:my-1.5 [&_a]:text-sky-800 [&_a]:underline [&_strong]:text-slate-900">
        <h1>{title}</h1>
        {children}
        <h2>Contact us</h2>
        <p>
          <strong>The Oncall Bot LLC</strong> (PractCom)<br />
          Email: <a href="mailto:admin@practcom.com">admin@practcom.com</a><br />
          Phone: <a href="tel:+15162361083">(516) 236-1083</a>
        </p>
      </main>
      <footer className="border-t border-slate-200 bg-slate-50 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center text-sm text-slate-500 flex flex-wrap justify-center gap-x-3 gap-y-1">
          <Link to="/landing" className="text-sky-800 font-semibold hover:underline">PractCom</Link>
          <Link to="/practcom/terms" className="hover:text-slate-700" data-testid="legal-footer-terms">Terms of Service</Link>
          <Link to="/practcom/privacy" className="hover:text-slate-700" data-testid="legal-footer-privacy">Privacy Policy</Link>
          <span>© {new Date().getFullYear()} The Oncall Bot LLC</span>
        </div>
      </footer>
    </div>
  );
};
